import { cloneElement, FC, isValidElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, FormHelperText } from '@mui/material';

import { RequiredLabelTooltip } from 'components/RequiredLabelTooltip/RequiredLabelTooltip';

import { FormFieldLabel } from './FormFieldLabel';
import { IFormFieldProps } from './types';

import styles from './FormField.module.scss';

export const FormField: FC<IFormFieldProps> = ({
  children,
  error,
  id,
  label,
  required,
  containerClass,
  disabled,
  omitErrorClone,
  requiredForAI = false,
  ...restProps
}) => {
  const { t } = useTranslation();
  const errorId = error ? `${id}-error` : '';
  const isInvalid = Boolean(error);

  const inputElement = isValidElement(children)
    ? cloneElement(children, {
        id,
        ...(!omitErrorClone && { error: isInvalid }),
        'aria-describedby': errorId,
        'aria-required': required,
      })
    : null;

  return (
    <Box className={containerClass} {...restProps}>
      {label && (
        <FormFieldLabel className={styles.label} htmlFor={id} disabled={disabled}>
          <RequiredLabelTooltip text={label} requiredForAI={requiredForAI} tooltipText={t('requiredForAI')} />
        </FormFieldLabel>
      )}
      {inputElement}
      {error && (
        <FormHelperText id={errorId} error={isInvalid} sx={{ marginTop: '4px' }}>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
};
